import { TalentAccount } from "../talents/talentAPI";

enum TalentAddressFormat {
  STREET_CITY = "STREET_CITY",
  STREET_CITY_ZIP = "STREET_CITY_ZIP",
}

const canFormatAddress = (
  account: TalentAccount,
  format: TalentAddressFormat,
) => {
  if (format === TalentAddressFormat.STREET_CITY_ZIP) {
    return (
      !!account?.address?.street &&
      !!account?.address?.zip &&
      !!account?.address?.city
    );
  }

  return !!account?.address?.street && !!account?.address?.city;
};

export const formatTalentAddress = (
  account: TalentAccount,
  format: TalentAddressFormat = TalentAddressFormat.STREET_CITY,
) => {
  if (format === TalentAddressFormat.STREET_CITY_ZIP) {
    return canFormatAddress(account, format)
      ? `${account?.address.street}, ${account.address.zip} ${account.address.city}`
      : "";
  }

  return canFormatAddress(account, format)
    ? `${account.address.street}, ${account.address.city}`
    : "";
};
